module.exports = __webpack_public_path__ + "img/ga.1f97ea14.svg";